(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-backup-20251114-161605"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.glassHeaderEnabled = this.classList.contains('parlay-glass-header');
      this.glassScrollThreshold = Number.parseInt(this.getAttribute('data-glass-scroll-threshold') || '18', 10);
      this.glassThresholdHysteresis = 8;
      this.disableGlassOnDrawerOpen = this.getAttribute('data-disable-glass-on-open') !== 'false';
      this.heroOverlayEnabled = this.getAttribute('data-hero-overlay') === 'true';
      this.headerBounds = {};

      this.setHeaderHeight();
      requestAnimationFrame(() => this.setHeaderHeight());
      window.addEventListener('load', () => this.setHeaderHeight(), { once: true });

      this.resizeHandler = () => this.setHeaderHeight();
      window.addEventListener('resize', this.resizeHandler);
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.setupMenuDrawerState();
      this.setupInlineShopToggles();
      this.setupHomeHeroState();
      this.applyHeaderVisualState(window.pageYOffset || document.documentElement.scrollTop);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.updateAnnouncementBarHeight();
    }

    updateAnnouncementBarHeight() {
      if (this.heroOverlayEnabled || window.location.pathname === '/' || window.location.pathname === '/index' || window.location.pathname.endsWith('/')) {
        let totalHeight = 0;
        const headerGroup = this.header.parentElement;
        if (headerGroup) {
          for (const child of headerGroup.children) {
            if (child === this.header) break;
            totalHeight += child.offsetHeight || 0;
          }
        }
        document.documentElement.style.setProperty('--announcement-bar-height', `${totalHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.resizeHandler) window.removeEventListener('resize', this.resizeHandler);
      if (this.menuDrawerDetails && this.menuDrawerToggleHandler) {
        this.menuDrawerDetails.removeEventListener('toggle', this.menuDrawerToggleHandler);
      }
      if (this.inlineShopToggles && this.inlineShopToggles.length) {
        this.inlineShopToggles.forEach((toggle) => toggle.removeEventListener('click', this.inlineShopToggleHandler));
      }
      if (this.homeHeroScrollHandler) window.removeEventListener('scroll', this.homeHeroScrollHandler);
      if (this.homeHeroResizeHandler) window.removeEventListener('resize', this.homeHeroResizeHandler);
      if (this.homeHeroTargetObserver) this.homeHeroTargetObserver.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    setupMenuDrawerState() {
      this.menuDrawerDetails = this.querySelector('#Details-menu-drawer-container');
      if (!this.menuDrawerDetails || !this.header) return;

      this.menuDrawerToggleHandler = () => {
        const isOpen = this.menuDrawerDetails.hasAttribute('open');
        this.header.classList.toggle('menu-drawer-open', isOpen);

        if (isOpen && this.disableGlassOnDrawerOpen) {
          this.header.classList.remove('parlay-glass-active');
          return;
        }

        this.applyHeaderVisualState(window.pageYOffset || document.documentElement.scrollTop);
      };

      this.menuDrawerDetails.addEventListener('toggle', this.menuDrawerToggleHandler);
    }

    setupInlineShopToggles() {
      this.inlineShopToggles = Array.from(this.querySelectorAll('[data-inline-shop-toggle]'));
      if (!this.inlineShopToggles.length) return;

      this.inlineShopToggleHandler = (event) => {
        const toggle = event.currentTarget;
        const inlineShop = toggle.closest('[data-inline-shop]');
        const content = inlineShop && inlineShop.querySelector('[data-inline-shop-content]');
        if (!content) return;

        const willExpand = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', willExpand ? 'true' : 'false');
        content.classList.toggle('hidden', !willExpand);
      };

      this.inlineShopToggles.forEach((toggle) => {
        toggle.addEventListener('click', this.inlineShopToggleHandler);
      });
    }

    getHomeHeroTarget() {
      const heroSelectors = [
        'main .parlay-hero',
        'main [class^="parlay-hero-"]',
        'main [class*=" parlay-hero-"]',
        'main .section-video-hero',
        'main .video-hero',
        'main .custom-hero',
        'main .hero-ag1',
        'main [class*="video-hero"]',
        'main .image-banner'
      ];
      for (const selector of heroSelectors) {
        const target = document.querySelector(selector);
        if (target) return target;
      }
      const mainElement = document.querySelector('main');
      if (!mainElement) return null;
      for (const child of Array.from(mainElement.children)) {
        if (
          child.classList.contains('shopify-section') ||
          child.tagName === 'SECTION' ||
          (child.id && child.id.indexOf('shopify-section-') === 0)
        ) {
          return child;
        }
      }
      return null;
    }

    setupHomeHeroState() {
      if (!this.header || !this.heroOverlayEnabled) return;
      this.homeHeroTarget = this.getHomeHeroTarget();
      if (!this.homeHeroTarget) return;
      this.updateHomeHeroState();
      this.homeHeroResizeHandler = () => this.applyHeaderVisualState(window.pageYOffset || document.documentElement.scrollTop);
      window.addEventListener('resize', this.homeHeroResizeHandler);
      this.homeHeroTargetObserver = new MutationObserver(() => this.applyHeaderVisualState(window.pageYOffset || document.documentElement.scrollTop));
      this.homeHeroTargetObserver.observe(this.homeHeroTarget, { attributes: true, childList: true, subtree: true });
    }

    updateHomeHeroState() {
      if (!this.header || !this.homeHeroTarget) {
        if (this.header) this.header.classList.remove('parlay-home-hero-active');
        return false;
      }
      const heroRect = this.homeHeroTarget.getBoundingClientRect();
      const headerHeight = this.header.offsetHeight || 0;
      const isHeroActive = heroRect.bottom > headerHeight;
      this.header.classList.toggle('parlay-home-hero-active', isHeroActive);
      return isHeroActive;
    }

    updateGlassState(scrollTop) {
      if (!this.glassHeaderEnabled || !this.header) return;
      if (this.disableGlassOnDrawerOpen && this.header.classList.contains('menu-drawer-open')) {
        this.header.classList.remove('parlay-glass-active');
        return;
      }
      if (this.header.classList.contains('parlay-home-hero-active')) {
        this.header.classList.remove('parlay-glass-active');
        return;
      }
      const threshold = Number.isNaN(this.glassScrollThreshold) ? 18 : this.glassScrollThreshold;
      const hysteresis = this.glassThresholdHysteresis || 8;
      const enterThreshold = threshold + hysteresis;
      const exitThreshold = Math.max(0, threshold - hysteresis);
      const isCurrentlyActive = this.header.classList.contains('parlay-glass-active');
      if (scrollTop >= enterThreshold || (isCurrentlyActive && scrollTop > exitThreshold)) {
        this.header.classList.add('parlay-glass-active');
      } else {
        this.header.classList.remove('parlay-glass-active');
      }
    }

    applyHeaderVisualState(scrollTop) {
      const isHeroActive = this.updateHomeHeroState();
      const threshold = Number.isNaN(this.glassScrollThreshold) ? 18 : this.glassScrollThreshold;
      const isHomeTop = Boolean(this.heroOverlayEnabled && isHeroActive && scrollTop <= threshold);
      this.header.classList.toggle('parlay-home-top', isHomeTop);
      this.updateGlassState(scrollTop);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.applyHeaderVisualState(scrollTop);

      if (this.predictiveSearch && this.predictiveSearch.isOpen) {
        this.currentScrollTop = scrollTop;
        return;
      }

      // Add minimum scroll delta threshold to reduce flickering
      const scrollDelta = Math.abs(scrollTop - this.currentScrollTop);
      if (scrollDelta < 5) {
        const topBound = this.headerBounds.top || 0;
        if (scrollTop <= topBound) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.glassHeaderEnabled = this.classList.contains('parlay-glass-header');
      this.glassScrollThreshold = Number.parseInt(this.getAttribute('data-glass-scroll-threshold') || '18', 10);
      this.glassThresholdHysteresis = 8;
      this.disableGlassOnDrawerOpen = this.getAttribute('data-disable-glass-on-open') !== 'false';
      this.heroOverlayEnabled = this.getAttribute('data-hero-overlay') === 'true';
      this.setHeaderHeight();
      requestAnimationFrame(() => this.setHeaderHeight());
      window.addEventListener('load', () => this.setHeaderHeight(), { once: true });

      window.addEventListener('resize', () => this.setHeaderHeight());
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      this.setupMenuDrawerState();
      this.setupInlineShopToggles();
      this.setupHomeHeroState();
      this.applyHeaderVisualState(window.pageYOffset || document.documentElement.scrollTop);
      this.onScrollHandler = () => this.applyHeaderVisualState(window.pageYOffset || document.documentElement.scrollTop);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.updateAnnouncementBarHeight();
    }

    updateAnnouncementBarHeight() {
      if (this.heroOverlayEnabled || window.location.pathname === '/' || window.location.pathname === '/index' || window.location.pathname.endsWith('/')) {
        let totalHeight = 0;
        const headerGroup = this.header.parentElement;
        if (headerGroup) {
          for (const child of headerGroup.children) {
            if (child === this.header) break;
            totalHeight += child.offsetHeight || 0;
          }
        }
        document.documentElement.style.setProperty('--announcement-bar-height', `${totalHeight}px`);
      }
    }

    disconnectedCallback() {
      if (this.onScrollHandler) window.removeEventListener('scroll', this.onScrollHandler);
      if (this.menuDrawerDetails && this.menuDrawerToggleHandler) {
        this.menuDrawerDetails.removeEventListener('toggle', this.menuDrawerToggleHandler);
      }
      if (this.inlineShopToggles && this.inlineShopToggles.length) {
        this.inlineShopToggles.forEach((toggle) => toggle.removeEventListener('click', this.inlineShopToggleHandler));
      }
      if (this.homeHeroScrollHandler) window.removeEventListener('scroll', this.homeHeroScrollHandler);
      if (this.homeHeroResizeHandler) window.removeEventListener('resize', this.homeHeroResizeHandler);
      if (this.homeHeroTargetObserver) this.homeHeroTargetObserver.disconnect();
    }

    setupMenuDrawerState() {
      this.menuDrawerDetails = this.querySelector('#Details-menu-drawer-container');
      if (!this.menuDrawerDetails || !this.header) return;

      this.menuDrawerToggleHandler = () => {
        const isOpen = this.menuDrawerDetails.hasAttribute('open');
        this.header.classList.toggle('menu-drawer-open', isOpen);

        if (isOpen && this.disableGlassOnDrawerOpen) {
          this.header.classList.remove('parlay-glass-active');
          return;
        }

        this.applyHeaderVisualState(window.pageYOffset || document.documentElement.scrollTop);
      };

      this.menuDrawerDetails.addEventListener('toggle', this.menuDrawerToggleHandler);
    }

    setupInlineShopToggles() {
      this.inlineShopToggles = Array.from(this.querySelectorAll('[data-inline-shop-toggle]'));
      if (!this.inlineShopToggles.length) return;

      this.inlineShopToggleHandler = (event) => {
        const toggle = event.currentTarget;
        const inlineShop = toggle.closest('[data-inline-shop]');
        const content = inlineShop && inlineShop.querySelector('[data-inline-shop-content]');
        if (!content) return;

        const willExpand = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', willExpand ? 'true' : 'false');
        content.classList.toggle('hidden', !willExpand);
      };

      this.inlineShopToggles.forEach((toggle) => {
        toggle.addEventListener('click', this.inlineShopToggleHandler);
      });
    }

    getHomeHeroTarget() {
      const heroSelectors = [
        'main .parlay-hero',
        'main [class^="parlay-hero-"]',
        'main [class*=" parlay-hero-"]',
        'main .section-video-hero',
        'main .video-hero',
        'main .custom-hero',
        'main .hero-ag1',
        'main [class*="video-hero"]',
        'main .image-banner'
      ];
      for (const selector of heroSelectors) {
        const target = document.querySelector(selector);
        if (target) return target;
      }
      const mainElement = document.querySelector('main');
      if (!mainElement) return null;
      for (const child of Array.from(mainElement.children)) {
        if (
          child.classList.contains('shopify-section') ||
          child.tagName === 'SECTION' ||
          (child.id && child.id.indexOf('shopify-section-') === 0)
        ) {
          return child;
        }
      }
      return null;
    }

    setupHomeHeroState() {
      if (!this.header || !this.heroOverlayEnabled) return;
      this.homeHeroTarget = this.getHomeHeroTarget();
      if (!this.homeHeroTarget) return;
      this.updateHomeHeroState();
      this.homeHeroResizeHandler = () => this.applyHeaderVisualState(window.pageYOffset || document.documentElement.scrollTop);
      window.addEventListener('resize', this.homeHeroResizeHandler);
      this.homeHeroTargetObserver = new MutationObserver(() => this.applyHeaderVisualState(window.pageYOffset || document.documentElement.scrollTop));
      this.homeHeroTargetObserver.observe(this.homeHeroTarget, { attributes: true, childList: true, subtree: true });
    }

    updateHomeHeroState() {
      if (!this.header || !this.homeHeroTarget) {
        if (this.header) this.header.classList.remove('parlay-home-hero-active');
        return false;
      }
      const heroRect = this.homeHeroTarget.getBoundingClientRect();
      const headerHeight = this.header.offsetHeight || 0;
      const isHeroActive = heroRect.bottom > headerHeight;
      this.header.classList.toggle('parlay-home-hero-active', isHeroActive);
      return isHeroActive;
    }

    updateGlassState(scrollTop) {
      if (!this.glassHeaderEnabled || !this.header) return;
      if (this.disableGlassOnDrawerOpen && this.header.classList.contains('menu-drawer-open')) {
        this.header.classList.remove('parlay-glass-active');
        return;
      }
      if (this.header.classList.contains('parlay-home-hero-active')) {
        this.header.classList.remove('parlay-glass-active');
        return;
      }
      const threshold = Number.isNaN(this.glassScrollThreshold) ? 18 : this.glassScrollThreshold;
      const hysteresis = this.glassThresholdHysteresis || 8;
      const enterThreshold = threshold + hysteresis;
      const exitThreshold = Math.max(0, threshold - hysteresis);
      const isCurrentlyActive = this.header.classList.contains('parlay-glass-active');
      if (scrollTop >= enterThreshold || (isCurrentlyActive && scrollTop > exitThreshold)) {
        this.header.classList.add('parlay-glass-active');
      } else {
        this.header.classList.remove('parlay-glass-active');
      }
    }

    applyHeaderVisualState(scrollTop) {
      const isHeroActive = this.updateHomeHeroState();
      const threshold = Number.isNaN(this.glassScrollThreshold) ? 18 : this.glassScrollThreshold;
      const isHomeTop = Boolean(this.heroOverlayEnabled && isHeroActive && scrollTop <= threshold);
      this.header.classList.toggle('parlay-home-top', isHomeTop);
      this.updateGlassState(scrollTop);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
